/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { SequenceEventOutScope } from './sequenceEventOutScope';

/**
 * One ephemeral outreach-changed signal (routing ids only, no PII).
 */
export interface SequenceEventOut {
  sequence_id?: string | null;
  job_id?: string | null;
  scope?: SequenceEventOutScope;
}
